import './components.css';

export function ConfidenceBar({ value, label }: { value: number; label?: string }) {
  const colour =
    value >= 80
      ? 'var(--status-operational)'
      : value >= 60
        ? 'var(--status-degraded)'
        : 'var(--status-critical)';
  return (
    <div className="iris-confidence">
      <div className="iris-confidence-track">
        <div
          className="iris-confidence-fill"
          style={{ width: `${value}%`, background: colour }}
        />
      </div>
      <span className="iris-confidence-value mono">
        {value}%{label ? ` ${label}` : ''}
      </span>
    </div>
  );
}
